// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage-documents .upload-file{width:600px;height:500px}`, "",{"version":3,"sources":["webpack://./src/modals/UploadDocument/style.scss"],"names":[],"mappings":"AAEE,+BACE,WAAA,CACA,YAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
